import { VA_FORM_IDS } from '@department-of-veterans-affairs/platform-forms/constants';
import { getTrackingDefaults, trackAction } from './datadogRumTracking';

// ──────────────────────────────────────────────
// AddPerson / ID generation tracking
// ──────────────────────────────────────────────

export const trackAddPersonInitiated = (formId = VA_FORM_IDS.FORM_21_526EZ) => {
  const { sourcePath } = getTrackingDefaults();
  trackAction('21-526EZ_id_generation_initiated', {
    formId,
    sourcePath,
  });
};

export const trackAddPersonFailed = (formId = VA_FORM_IDS.FORM_21_526EZ) => {
  const { sourcePath } = getTrackingDefaults();
  trackAction('21-526EZ_id_generation_failed', {
    formId,
    sourcePath,
  });
};

export const trackAddPersonSucceeded = (formId = VA_FORM_IDS.FORM_21_526EZ) => {
  const { sourcePath } = getTrackingDefaults();
  trackAction('21-526EZ_id_generation_succeeded', {
    formId,
    sourcePath,
  });
};
